// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"76569a3d","340":"cc3e8a9f"}[chunkId] + ".chunk.css";
};